module.exports = __webpack_public_path__ + "img/affordable.c81a5076.jpg";